!<!--  -->
<template>
  <div class="">
    <el-dialog
      :close-on-click-modal="false"
      center
      :title="title"
      :visible.sync="showDialog"
      :width="width"
      :show-close="showClose"
    >
      <div style="">
        <slot :testSolt="tesObj"> </slot>
      </div>
      <div class="table_wrap">
        <slot name="main"></slot>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <slot name="button"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    width: {
      type: String,
      default: "85%",
    },
    title: {
      type: String,
      default: "",
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    addObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    //这里存放数据
    return {
      tesObj: { te: 21 },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    clearAll() {
      this.$emit("clearAll");
    },
    submit() {
      this.$emit("submit");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
</style>>



// WEBPACK FOOTER //
// src/components/QuotationManagement/jack-components/erp-copy/add-dialog-plus.vue